module.exports = __webpack_public_path__ + "img/HHCarousel_router.d4bc60db.webp";